import styled from 'styled-components';
import { CloseIcon } from '@gif/shared-ui';

import { translate } from '../../../configs';
import { light } from '@mlb/play-ui';

const CloseButton = styled.button`
  padding: 0.5rem;
  border: none;
  background-color: white;
  position: absolute;
  right: 10px;
  top: 10px;

  svg {
    height: 1.25rem;
    width: 1.25rem;
    color: ${light.fontColor};
  }

  &:hover {
    cursor: pointer;
  }
`;

const StyledAddInfoModalHeader = styled.header`
  display: flex;
  justify-content: center;
  position: relative;
  height: 3.75rem;
  border-bottom: solid 1px #dddddd;

  h1 {
    font-weight: 600;
    text-align: center;
    font-size: 1rem;
    margin: auto;
    color: ${light.fontColor};
  }
`;

const closeText = translate('close');
const closeButtonId = 'addInfoModalHeader-closeModalIcon';

interface AddInfoModalHeaderProps {
  onClose?: (e: React.MouseEvent) => void;
}

export const AddInfoModalHeader = ({ onClose }: AddInfoModalHeaderProps) => {
  return (
    <StyledAddInfoModalHeader>
      <h1>{translate('additionalInformation')}</h1>
      <CloseButton
        role="button"
        data-testid={closeButtonId}
        id={closeButtonId}
        aria-label={closeText}
        onClick={onClose}
      >
        <CloseIcon title={closeText} />
      </CloseButton>
    </StyledAddInfoModalHeader>
  );
};

export default AddInfoModalHeader;
